import { useMemo } from "react";
import { FlipperVaultCardProps } from "../../stories/common/flipper-vault-card";

export type CardState =
  | "checkedOutByOther"
  | "checkedOutByMe"
  // | "released"
  | "canCheckout"
  | "locked"
  | "expiredByOther"
  | "expiredByMe"
  | "OwnerAndReleasedByOther"
  | "OwnerAndReleasedByOwner"
  | null;

interface UseFlipperStateProps {
  flipperData: FlipperVaultCardProps;
  userId: string | undefined;
  isExpired: boolean;
}

export const useFlipperState = ({
  flipperData,
  userId,
  isExpired
}: UseFlipperStateProps): CardState => {
  const { checkouts, owner, vaultOwnerId, bidCount } = flipperData;
  const lastCheckout = checkouts?.[checkouts?.length - 1];
  // const isOwner = owner?.[0]?.id === userId;

  return useMemo<CardState>(() => {
    if (vaultOwnerId !== null) {
      if (vaultOwnerId === userId) {
        // show My Vault
        return null;
      } else {
        if (lastCheckout?.userId === userId) {
          if (isExpired) {
            return "expiredByMe";
          } else {
            if (bidCount && bidCount > 0) {
              return "checkedOutByMe";
            } else {
              return "checkedOutByMe";
            }
          }
        } else {
          return null;
        }
      }
    } else {
      if (owner?.[0].id === userId) {
        // owner and watching my account
        if (checkouts?.length > 0) {
          if (lastCheckout?.userId !== userId) {
            if (lastCheckout?.releasedAt !== null) {
              // have release data
              // show release by user Name in bottom bar and status will release
              return "OwnerAndReleasedByOther";
            } else if (isExpired) {
              // last checkout release date is null
              // check for expired condition
              // show expired by user name and status expired
              return "expiredByOther";
            } else {
              // show checked out by user name and timer in bottom bar and status will by checked out
              return "checkedOutByOther";
            }
          } else {
            if (lastCheckout?.releasedAt !== null) {
              // have release data
              // show release by user Name in bottom bar and status will release
              return "OwnerAndReleasedByOwner";
            } else if (isExpired) {
              // last checkout release date is null
              // check for expired condition
              // show expired by user name and status expired
              return "expiredByMe";
            } else {
              // show checked out by user name and timer in bottom bar and status will by checked out
              return "checkedOutByMe";
            }
          }
        } else {
          // show nothing in bottom bar status also null
          if (bidCount && bidCount > 0) {
            return null;
          } else {
            return "canCheckout";
          }
        }
      } else {
        // not owner and watching other's account
        if (checkouts?.length > 0) {
          if (lastCheckout?.releasedAt !== null) {
            if (lastCheckout?.userId === userId) {
              // checked out by me and released
              return null;
            } else {
              // not checked out by me and released by other
              // can see checkout button
              // add condition for multiple checkout are released
              if (flipperData?.hasCheckedOutByMe === "1") {
                return null;
              }
              return "canCheckout";
            }
          } else if (isExpired) {
            // release date is null
            // is expired
            if (lastCheckout?.userId === userId) {
              // checked out by me and expired by me
              // show expiredd
              return "expiredByMe";
            } else {
              // show Locked
              return null;
            }
          } else {
            if (lastCheckout?.userId === userId) {
              // show release button and timer
              return "checkedOutByMe";
            } else {
              // show Locked
              return null;
            }
          }
        } else {
          if (bidCount && bidCount > 0) {
            return null;
          } else {
            return "canCheckout";
          }
        }
      }
    }
  }, [
    isExpired,
    // isOwner,
    vaultOwnerId,
    lastCheckout,
    userId,
    checkouts?.length,
    owner
  ]);
};
